import { Context, css, Href, styled, Text } from '@obvio/app'
import { FluidGridView } from '@obvio/template'
import { Section } from '@obvio/ui'

import { Art } from '../Art'
import { ReadMoreLink } from '../ReadMoreLink'

import type { Data } from '@/pages/artist/[name]'
import type { ReactElement } from 'react'

const Info = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ArtFluidGrid = styled(FluidGridView)`
  button {
    color: black;
  }
`

const outerCss = css`
  margin-bottom: ${(theme) => theme.spacing.extraLarge};
`
type Work = Data['products']

type ArtistWorksProps = {
  works: Work
  merchant: { id: string; name: string }
}

export function ArtistWorks({
  works,
  merchant,
}: ArtistWorksProps): ReactElement | null {
  const artworks = works.map((v) => ({ ...v, merchant }))

  if (artworks.length === 0) {
    return null
  }
  return (
    <Context name="withGrid">
      <Section outerCss={outerCss}>
        <Info>
          <Text tag="h3" as="h5">
            Selected Works
          </Text>
          <ReadMoreLink
            color="black"
            length="3rem"
            href={new Href('/store', { search: merchant.name })}
          >
            ARTSHOP
          </ReadMoreLink>
        </Info>
      </Section>
      <ArtFluidGrid
        data={artworks}
        element={(data) => <Art artwork={data} />}
        select={() => null}
      />
    </Context>
  )
}
